'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContainerBase = require('./ContainerBase');

var _ContainerBase2 = _interopRequireDefault(_ContainerBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  height: _propTypes2.default.string,
  maxHeight: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string,
  minHeight: _propTypes2.default.string,
  minWidth: _propTypes2.default.string,
  width: _propTypes2.default.string,

  margin: _propTypes2.default.string,
  marginLeft: _propTypes2.default.string,
  marginRight: _propTypes2.default.string,
  marginTop: _propTypes2.default.string,
  marginBottom: _propTypes2.default.string,
  marginSides: _propTypes2.default.string,

  padding: _propTypes2.default.string,
  paddingLeft: _propTypes2.default.string,
  paddingRight: _propTypes2.default.string,
  paddingTop: _propTypes2.default.string,
  paddingBottom: _propTypes2.default.string,
  paddingSides: _propTypes2.default.string,
  withPadding: _propTypes2.default.bool,

  border: _propTypes2.default.string,
  borderColor: _propTypes2.default.string,
  dashed: _propTypes2.default.bool,
  rounded: _propTypes2.default.bool,

  default: _propTypes2.default.bool,
  primary: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  warning: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  muted: _propTypes2.default.bool,

  white: _propTypes2.default.bool,
  black: _propTypes2.default.bool,
  red: _propTypes2.default.bool,
  blue: _propTypes2.default.bool,
  purple: _propTypes2.default.bool,
  yellow: _propTypes2.default.bool,
  green: _propTypes2.default.bool,

  lighter: _propTypes2.default.bool,
  light: _propTypes2.default.bool,
  lightest: _propTypes2.default.bool,

  textLeft: _propTypes2.default.bool,
  textCenter: _propTypes2.default.bool,
  textRight: _propTypes2.default.bool,

  shadow: _propTypes2.default.bool,
  heavyShadow: _propTypes2.default.bool,
  animate: _propTypes2.default.bool,

  flex: _propTypes2.default.bool,
  flexInline: _propTypes2.default.bool,
  flexRow: _propTypes2.default.bool,
  flexColumn: _propTypes2.default.bool,
  flexWrap: _propTypes2.default.bool,
  justifyStart: _propTypes2.default.bool,
  justifyEnd: _propTypes2.default.bool,
  justifyCenter: _propTypes2.default.bool,
  justifySpaceBetween: _propTypes2.default.bool,
  justifySpaceAround: _propTypes2.default.bool,
  alignStart: _propTypes2.default.bool,
  alignEnd: _propTypes2.default.bool,
  alignCenter: _propTypes2.default.bool,
  alignSpaceBetween: _propTypes2.default.bool,
  alignSpaceAround: _propTypes2.default.bool,

  direction: _propTypes2.default.string,
  alignItems: _propTypes2.default.string,
  alignContent: _propTypes2.default.string,
  justifyContent: _propTypes2.default.string,
  alignSelf: _propTypes2.default.string,
  flexBasis: _propTypes2.default.string,
  flexGrow: _propTypes2.default.number,
  flexShrink: _propTypes2.default.number,

  withOutline: _propTypes2.default.bool
};

var defaultProps = {
  height: null,
  maxHeight: null,
  maxWidth: null,
  minHeight: null,
  minWidth: null,
  width: null,

  margin: null,
  marginLeft: null,
  marginRight: null,
  marginTop: null,
  marginBottom: null,
  marginSides: null,

  padding: '20px',
  paddingLeft: '',
  paddingRight: '',
  paddingTop: '',
  paddingBottom: '',
  paddingSides: '',
  withPadding: false,

  border: 'none',
  borderColor: '',
  dashed: false,
  rounded: false,

  default: false,
  primary: false,
  success: false,
  warning: false,
  error: false,
  muted: false,

  white: false,
  black: false,
  red: false,
  blue: false,
  purple: false,
  yellow: false,
  green: false,

  lighter: false,
  light: false,
  lightest: false,

  textLeft: false,
  textCenter: false,
  textRight: false,

  shadow: false,
  heavyShadow: false,
  animate: false,

  flex: false,
  flexInline: false,
  flexRow: false,
  flexColumn: false,
  flexWrap: false,
  justifyStart: false,
  justifyEnd: false,
  justifyCenter: false,
  justifySpaceBetween: false,
  justifySpaceAround: false,
  alignStart: false,
  alignEnd: false,
  alignCenter: false,
  alignSpaceBetween: false,
  alignSpaceAround: false,

  direction: '',
  alignItems: '',
  alignContent: '',
  justifyContent: '',
  alignSelf: '',
  flexBasis: '',
  flexGrow: null,
  flexShrink: null,

  withOutline: false
};

var Container = function Container(props) {
  return _react2.default.createElement(_ContainerBase2.default, props);
};

Container.displayName = 'hui:Container';

Container.huiName = 'Container';

Container.propTypes = propTypes;

Container.defaultProps = defaultProps;

exports.default = Container;
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ../container/lib/Container.js
// module id = 259
// module chunks = 0